/**
 * Hook customizado para i18n
 * 
 * Fornece funcionalidades adicionais além do useTranslation padrão
 */

import { useTranslation } from 'react-i18next';
import type { SupportedLanguage } from '@/shared/i18n';
import i18n from '@/shared/i18n/config';

export function useI18n() {
  const { t, i18n: i18nInstance } = useTranslation();

  /**
   * Altera o idioma da aplicação
   */
  const changeLanguage = async (lng: SupportedLanguage) => {
    await i18nInstance.changeLanguage(lng);
  };

  /**
   * Retorna o idioma atual
   */
  const currentLanguage = i18nInstance.language as SupportedLanguage;

  /**
   * Verifica se o idioma atual é o especificado
   */
  const isLanguage = (lng: SupportedLanguage) => {
    return currentLanguage === lng;
  };

  /**
   * Retorna todos os idiomas suportados
   */
  const supportedLanguages: SupportedLanguage[] = ['en', 'pt-BR', 'es'];

  return {
    t,
    changeLanguage,
    currentLanguage,
    isLanguage,
    supportedLanguages,
    i18n: i18nInstance,
  };
}


